import { render, staticRenderFns } from "./UserConfirmation.vue?vue&type=template&id=671a0485&"
import script from "./UserConfirmation.vue?vue&type=script&lang=ts&"
export * from "./UserConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./UserConfirmation.vue?vue&type=style&index=0&id=671a0485&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSnackbar,VTextField})
